import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-brand-gray px-8 py-16 mt-20 border-t border-brand-light-gray">
      <div className="container mx-auto text-center">
        <h3 className="text-4xl font-bold mb-4">Ready to build what's next?</h3>
        <p className="text-brand-text-dark mb-8">Reach out to discuss your project with one of our experts.</p>
        <a href="mailto:contact@dcconsulting.cc" className="text-2xl text-brand-primary hover:underline">
          contact@dcconsulting.cc
        </a>
        <div className="mt-12 text-sm text-brand-text-dark">
          <p>&copy; {new Date().getFullYear()} DC Consulting LLC. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 